import { Button, Modal, InlineNotification, TextBox, Toggle, Select } from "@veneer/core";
import React, { useState, useEffect } from "react";
import ConnectAPI from "../../../services/api";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

const ModifyUserData = (props) => {
    //Variables
    const connectApi = new ConnectAPI();
    const { t, i18n } = useTranslation();
    const [showNotification, setShowNotification] = useState(false);
    const [notificationDetails, setNotificationDetails] = useState({ title: '', type: '', description: '' });
    const [showButton, setShowButton] = useState(false);
    const [reloadButton, setReloadButton] = useState(false);
    const [active, setActive] = useState(false);
    const [sendMail, setSendMail] = useState(false);
    const [activeFlag, setActiveFlag] = useState(true);
    const [activeHP, setActiveHP] = useState(true);
    const [roleModal, setRoleModal] = useState();
    const [subRegion, setSubRegion] = useState({value: []});
    const [copyView, setCopyView] = useState(props.channelViewNew );
    const [endUserView, setEnduserView] = useState([]);
    const [idChannel, setIdChannel] = useState();
    const [idEndUser, setIdEndUser] = useState();

    //Metodos
    useEffect(() => {
        if(activeFlag & props.showModal){
            setActive(props.item.active?.toLowerCase?.() === 'true');
            setSendMail(props.item.sendEmailAboutOrders?.toLowerCase?.() === 'true')
            valueRoleinit(props.item.role);
            handleSubRegionInit( props.item.subRegion );
            setActiveFlag(false);
            checkEditHP();
            valueChannel(props.item.customer, props.item.endUser);
        }
     });
    function uploadAllDataButton(){
        let data = new FormData();
            data.append("Action", "UpdateUser");
            data.append("active", active?1:0);
            data.append("sendEmailAboutOrders", sendMail?1:0);
            data.append("idRole", roleModal);
            data.append("idSubRegion", subRegion.value);
            data.append("idUser", props.item.email);
            data.append("idCustomer", idChannel);
            data.append("idEndUser", idEndUser);
        const handleUploadResponse = (status, response) => {
            if (response === 'allGood') {
                setNotificationDetails({
                    title: t("notifyAllCorrect"),
                    type: 'positive',
                    description: ''
                });
                setReloadButton(true);
            } else {
                setNotificationDetails({
                    title: t("notifyWrognSQL"),
                    type: 'negative',
                    description: t("notifySQLError")
                });
            }
            setShowNotification(true);
        }
        connectApi.post(
            "api/Channels/uploadUserAdd",
            data,
            handleUploadResponse
        ).catch((error) => {
            props.setShowModal(false);
            Swal.fire(
                "Error " + error.response.status,
                error.response.data, "error"
            );
        });
    }
    function checkDataModify(){
        let strIn = subRegion.value.toString();
        const valueCopy = [];
        let str = props.item.subRegion+"";
        const arr = str.split(',');
        arr.forEach((x) => {
            const item = props.regionList.find((y) => y.label === x.trim());
            if(item)
                valueCopy.push(item.value);
        });
        let strForeing = {value: valueCopy};
        let item = props.roleList.find((y) => y.label.replace(/([\r\n ])/g, '') === props.item.role.replace(/([\r\n ])/g, ''));
        if(active.toString() === props.item.active.toLowerCase() && sendMail.toString() === props.item.sendEmailAboutOrders.toLowerCase() && 
        roleModal[0].toString() === item.value.toString() && strForeing.value.toString() === strIn && 
        idChannel.toString()===props.item.idCustomer && idEndUser.toString()===props.item.idEndUser){
            setNotificationDetails({
                title: t("notifyWrongValues"),
                type: 'negative',
                description: t("editOneItem")
            });
            setShowNotification(true);
        } else if(subRegion.value.length === 0){
            setNotificationDetails({
                title: t("notifyWrongValues"),
                type: 'negative',
                description: t("error.gettingData") + ": " + t('Subregion')
            });
            setShowNotification(true);
        } else
            uploadAllDataButton();
    }
    const closeOption = () => {
        props.setShowModal(false); 
        setShowButton(false);
        setActiveFlag(true);
        setActiveHP(true);
        setSubRegion({ value: [] });
        setRoleModal([]);
        setIdEndUser([]);
        setIdChannel([]);
    }
    const checkActive = (event) =>{
        setActiveFlag(false);
        setActive(event);
    }
    const checkSendMail = (event) =>{
        setActiveFlag(false);
        setSendMail(event);
    }
    const checkEditHP = () => {
        setActiveFlag(false);
        let srts = "";
        props.item.email? (srts = props.item.email):(srts="default");
        if( srts.includes("@hp.com") )
            setActiveHP(false);
    }
    const handleSubRegionInit = ( arg ) => {
        if (arg !== "" ){
            const valueCopy = [...subRegion.value];
            let str = arg+"";
            const arr = str.split(',');
            arr.forEach((x) => {
                const item = props.regionList.find((y) => y.label === x.trim());
                if(item)
                    valueCopy.push(item.value);
            });
            setSubRegion({ value: valueCopy });
        }
    }
    const valueChannel = ( channel, endUser ) => {
        if(!copyView.find((y) => y.label === "HP"))
            copyView.push({ value: "HP", label: "HP", });
        if (channel !== "" ){
            let str = channel+"";
            const item = copyView.find((y) => y.label === str);
            if(item === undefined){
                let item = { value: props.item.idCustomer, label: props.item.customer };
                copyView.push(item);
                setIdChannel([item.value]);
                if( endUser !=="" )
                    fetchEndUsers([item.value]);
            } else{
                setIdChannel([item.value]);
                if( endUser !== "" )
                    fetchEndUsers([item.value]);
            }
        }
    }
    const handleChangeSubregions = ({ value }) => {
        const valueCopy = [...subRegion.value];
        const isOptionSelected = valueCopy.includes(value);
        if (isOptionSelected) {
          const index = valueCopy.indexOf(value);
          valueCopy.splice(index, 1);
        } else
          valueCopy.push(value);
        
        setSubRegion({ value: valueCopy });
    }
    const valueRoleinit = ( arg ) => {
        if (arg !== "" ){
            let str = arg+"";
            const item = props.roleList.find((y) => y.label.replace(/([\r\n ])/g, '') === str.replace(/([\r\n ])/g, ''));
            setRoleModal([item.value]);
        }
    }
    const fetchEndUsers = (channel) => {
        connectApi.get("api/Channels/endUsers",{
            params:{
                customerId: channel,
                status: "Active",
            }
        },EndUserListData).catch((error) => {
            Swal.fire(
                "Error " + error?.response,
                error?.response,
                "error"
            );
        });
    };
    const EndUserListData = (status, data) => {
        const items = data.map((item) => {
            return{
                value: item.idEndUser,
                label: item.endUserName,
            };
        });
        items.push({ value: "HP", label: "HP", });
        let str = props.item.endUser+"";
        const itemFind = items.find((y) => y.label === str);
        setIdEndUser([itemFind.value]);
        setEnduserView(items);
    };
    const updateListEndUser = (val) => {
        setIdEndUser(undefined);
        setIdChannel([val.value]);
        fetchEndUsers(val.value);
    }
    //vista
    return (
        <Modal
            id="form-modal"
            onClose={reloadButton?(() => window.location.reload(false)) : (() => closeOption())}
            closeButton={true}
            show={props.showModal}
            title={ "Modify User Data" }
            footer={(
                <div className="vn-button-group--responsive">
                    <Button onClick={checkDataModify} >{t('upload')}</Button>
                    { reloadButton ? (
                        <Button appearance="secondary" onClick={() => {window.location.reload(false)}}> Close </Button>
                    ) : (
                        <Button appearance="secondary" onClick={() => closeOption()}> Close </Button>
                    ) }
                </div>
            )}
        >
            <label>{t("channel")}</label>
            <Select
                clearIcon={false}
                value={idChannel}
                options={copyView}
                onChange={val => updateListEndUser(val)}
                placeholder={t('select_channel')}
                readOnly = {activeHP}
            /> <br />
            <label>{t("endUserName")}</label>
            <Select
                clearIcon={false}
                value={idEndUser}
                options={endUserView}
                onChange={(val) => setIdEndUser([val.value])}
                placeholder={t('selectEndUser')}
                readOnly = {activeHP}
            /> <br />
            <label>{t('contactName')}</label>
            <TextBox
                id="idName"
                value={props.item.name || ''}
                readOnly
            /> <br />
            <label>{t('Email')}</label>
            <TextBox
                id="idEmail"
                value={props.item.email || ''}
                readOnly
            /> <br />
            <label>{t("active")}</label> <br />
            <Toggle
                id="idActive"
                on={active}
                onChange={checkActive}
            />
            <div style={{ marginLeft: '150px', marginTop: '-53px' }} >
                <label>{t("sendMailOrders")}</label> <br />
                <Toggle
                    id="idSendmail"
                    on={sendMail}
                    onChange={checkSendMail}
                /> 
            </div>
            <br />
            <label>{t("Country")}</label>
            <TextBox
                id="idCountry"
                value={props.item.idCountry || ''}
                readOnly
            /> <br />
            <label>{t("select region")}</label>
            <Select
                multiple
                options={props.regionList}
                id="subregion"
                placeholder={t('selectOption')}
                value={subRegion.value}
                onClear={() => setSubRegion({value: []})}
                onChange={handleChangeSubregions}
                readOnly = {activeHP}
            /> <br />
            <label>{t("selectRole")}</label>
            <Select
                options={props.roleList}
                value={roleModal}
                placeholder={t('selectOption')}
                onChange={(val) => { setRoleModal([val.value]) }}
                readOnly = {activeHP}
                clearIcon = {false}
            /> <br />
            {showNotification ? (
                <div className="show-animated" style={{ marginTop: '28px', marginBottom: '-16px' }}>
                    <InlineNotification
                        title={notificationDetails.title}
                        type={notificationDetails.type}
                        description={notificationDetails.description}
                        onClose={() => { setShowNotification(false) }}
                    />
                </div>
            ) : undefined}

        </Modal>
    );
}

export default ModifyUserData;
